import { ArrowRightSmall as ArrowRightSmall_kojaro } from './ArrowRightSmall.kojaro';
import { ArrowRightSmall as ArrowRightSmall_phosphor } from './ArrowRightSmall.phosphor';
import { ArrowRightSmall as ArrowRightSmall_zoomg } from './ArrowRightSmall.zoomg';
import { ArrowRightSmall as ArrowRightSmall_zoomit } from './ArrowRightSmall.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return ArrowRightSmall_kojaro;

    case 'zoomg':
      return ArrowRightSmall_zoomg;

    case 'phosphor':
      return ArrowRightSmall_phosphor;

    default:
      return ArrowRightSmall_zoomit;
  }
};

export const ArrowRightSmall = IconRenderer();
